import { createContext } from 'react';

export type ChangeUserRoleCtx = {
  showChangeUserRoleSuccessAlert: boolean;
  showChangeUserRoleErrorAlert: boolean;
  ChangeUserRoleError: string;
};

const ChangeUserRoleContext = createContext<ChangeUserRoleCtx>({
  showChangeUserRoleSuccessAlert: false,
  showChangeUserRoleErrorAlert: false,
  ChangeUserRoleError: '',
});

export default ChangeUserRoleContext;
